'use strict';

var utils = require('./../utils');

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/lib/helpers/isAxiosError.js
 ** module id = 514
 ** module chunks = 0
 **/